import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Metadata } from '../../util/types';

export default function PageViewer({meta}: {meta:Metadata}) {
	return (
		<Box>
			<Typography display="inline" variant="caption">created: {meta.created.ts}</Typography><br/>
			{
				(meta.modified) ? (
					<Typography display="inline" variant="caption">modified: {meta.modified.ts}</Typography>
				) : (<></>)
			}
			<Typography display="inline" variant="caption">archived:</Typography><br />
			<Typography display="inline" variant="caption">deleted:</Typography><br />
			<Typography display="inline" variant="caption">user:</Typography><br />
			<Typography display="inline" variant="caption">admin:</Typography><br />
			{/*
			<Typography display="inline" variant="caption">team:</Typography><br />
			<Typography display="inline" variant="caption">organization:</Typography><br />
			*/}
		</Box>
	)
}
